import { render, staticRenderFns } from "./BtnMostrarConteudo.vue?vue&type=template&id=3abb7628&"
import script from "./BtnMostrarConteudo.vue?vue&type=script&lang=js&"
export * from "./BtnMostrarConteudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports